import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const oAuthService = inject(OAuthService);

  if (oAuthService.hasValidAccessToken()) {
    if (state.url.indexOf('standard/details') > -1) localStorage.setItem('gs1-ecli-standard-state', state.url);
    if (state.url.indexOf('/apim/connexion') > -1) localStorage.setItem('gs1-ecli-state-apim', state.url);
    if (state.url.indexOf('operation=SignOut') > -1) {
      localStorage.removeItem('gs1-ecli-state-apim');
      return router.createUrlTree(['/']);
    }
    return true;
  } else {
    const refusedAccess = {
      url: state.url,
      date: Date.now(),
    };
    localStorage.setItem('gs1-ecli-previous-state', JSON.stringify(refusedAccess));
    return router.createUrlTree(['autologin']);
  }
};
